import { Expose } from 'class-transformer';

import { ExposeRawData } from '@lib/common/decorators';
import { SnModel } from '@lib/common/models';

import { SnWidgetMedia } from './widget-media';
import { SnWidgetObject } from './widget-object';

export class SnWidget extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public name: string;

  @Expose()
  public hidden: boolean;

  @Expose()
  public col: number;

  @Expose()
  public row: number;

  @Expose()
  public width: number;

  @Expose()
  public height: number;

  @Expose()
  public widget: string;

  @Expose()
  public content: string;

  @Expose()
  public isPinned: boolean;

  @ExposeRawData()
  public meta: any;

  @Expose()
  public widgetObjects: SnWidgetObject[];

  @Expose()
  public files: any[];

  @Expose()
  public media: SnWidgetMedia[];

  @Expose()
  public operationalView: string;

  @Expose()
  public createdTimestamp: string;

  @Expose()
  public updatedTimestamp: string;

  public popout: boolean = false;

  constructor(data?: any) {
    super();
    this.fromJSON(data);
  }
}
